<template>
  <div
    v-if="currency && price && commissionPercentage > 0"
    class="subheading greyDarken3--text"
  >
    There will be
    <b>{{ getCurrencySymbol(currency) }}{{ getSystemShare }}</b>
    ({{ commissionPercentage }} %) system commission share set on your
    organization, on each ticket sale.
  </div>
</template>

<script>
import { currencySymbol } from "@/mixins/monetization";
export default {
  name: "SystemShareView",
  props: {
    currency: {
      default: null,
    },
    price: {
      default: null,
    },
    commissionPercentage: {
      default: null,
    },
  },
  computed: {
    getSystemShare() {
      if (this.price) {
        return (this.price * this.commissionPercentage) / 100;
      }
      return 0;
    },
  },
  mixins: [currencySymbol],
};
</script>

<style>
</style>
